module.exports = __webpack_public_path__ + "static/media/ic_wallet_myway.97980ee3.svg";